import React from 'react';
import Svg from 'svg-inline-react';
import LogoSvg from '@src/svgs/meet-frank-logo-dark.svg';
import './styles.scss';

function SimpleHeader() {
  return (
    <div className="simple-header">
      <Svg src={LogoSvg} />
    </div>
  );
}

export default SimpleHeader;
